'use strict'

module.exports = {
    createSkinCss: require('./createSkinCss'),
    renderParam: require('./params').renderParam
}


// WEBPACK FOOTER //
// ./src/runtime/index.js